export enum PaymentMethodOptions {
  CHK = 'CHK',
  TRF = 'TRF',
  TRA = 'TRA',
  DD = 'DD',
}
